import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { BlackColorNum, BrownColorTypo, PagiLayout, CardLayout, CountCard, CountCard2, CountLayOut, ExpiringLeadLayout, GreenTypo, GreyTypo, Header, Header2, LeadCard, LeadIconBox, LeadNo, LeadNoText, OppoIconBox, Parent, RedTypo, SkyBlueTypo, Text, TodayLeadLayOut, WishesLayout, FilledDotSelected, CountCard3, PendingCofCard } from './DashStyledCss'
import { Box, Grid, Typography, Tooltip, Menu, MenuItem, Button, Fade, Zoom, Slide } from '@mui/material'
import { CalenderCard, CalenderIcon, CompanyIcon, FloatingButton, LeadIcon, NotificationIcon, OpportunityIcon, PaginationFooter, TaskIcon, UserIcon } from '../../components/custom'
import DashboardCard from './DashboardCard'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ContactIcon from '../../components/custom/ContactIcon'
import NotificationModal from '../../components/custom/NotificationsModal';
import themeColor from '../../Theme/themeColor'
import { H3SubHeader, T2popupSubText } from '../../Theme/theme'
import BackwardIcon from '../../components/custom/BackwardIcon'
import ForwardIcon from '../../components/custom/ForwardIcon'
import PaginationDot from '../../components/custom/PaginationDot'
import dayjs from 'dayjs'
import { dashboardcount, expiryleadthunk, todayleadthunk } from '../../Redux/Thunk/dashboardthunk'
import moment from 'moment'
import FloatingListModal from '../../components/custom/FloatingListModal';
import TableIcon from '../../components/custom/TableIcon'
import { TailSpin } from 'react-loader-spinner'
import AdminRole from '../../adminrole/Adminrole';
import ResetIcon from '../../components/custom/ResetIcon'

let dash = {
    For: "dashboard",
    view: "expiring_lead"
}

const Dashboardnew = () => {
    const { user } = useSelector((state) => state.auth)
    const [todayLeadPage, settodayLeadPage] = useState(1);
    const [expiryLeadPage, setExpiryLeadPage] = useState(1);
    const permissionsDetails = user?.data?.user?.role?.permissions
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false);
    const [start_date, setStart_Date] = useState(dayjs().startOf('month'));
    const [end_date, setEnd_Date] = useState(dayjs().endOf('day'));
    const [opennotificationmodal, setOpenNotificationModal] = useState(false)
    const dashboard_count = useSelector((state) => state?.dashboard?.dash_count?.data)
    const today_lead = useSelector((state) => state?.dashboard?.today_lead?.data)
    const expiry_lead = useSelector((state) => state?.dashboard?.expiry_lead?.data)
    const [openCalender, setOpenCalender] = useState(false)
    const [loader, setLoader] = useState(false)
    const notification_data = useSelector((state) => state?.dashboard?.notifications?.data)
    const [days, setDays] = useState('')
    const [checkAdminRole, setCheckAdminRole] = useState(AdminRole())

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (value) => {
        setOpen(false);
    };

    const openNotificationModal = () => {
        setOpenNotificationModal(true)
    }

    const handlecloseNotificationModal = () => {
        setOpenNotificationModal(false)
    }

    useEffect(() => {
        dispatch(dashboardcount({ start_date, end_date }));
    }, [start_date, end_date]);

    useEffect(() => {
        setEnd_Date(dayjs().endOf('day'))
    }, [start_date])

    const handleResetDate = () => {
        setStart_Date(dayjs().startOf('month'))
        setEnd_Date(dayjs().endOf('month'))
    }

    useEffect(() => {
        setLoader(true);
        Promise.all([
            dispatch(todayleadthunk({ start: (todayLeadPage * 4 - 4), length: 4 })),
            dispatch(expiryleadthunk({ start: (expiryLeadPage * 4 - 4), length: 4 }))
        ]).finally(() => setLoader(false));
    }, [todayLeadPage, expiryLeadPage]);

    const handleTodayLeadNext = useCallback(() => {
        if (todayLeadPage > 3) {
            settodayLeadPage(1)
        } else if (todayLeadPage === 2 && today_lead?.totalRecords > 8) {
            settodayLeadPage(3)
        } else if (todayLeadPage === 1 && today_lead?.totalRecords > 4) {
            settodayLeadPage(2)
        }
    }, [todayLeadPage, today_lead?.totalRecords]);

    const handleTodayLeadBack = () => {
        if (todayLeadPage < 1) {
            settodayLeadPage(3)
        } else if (todayLeadPage === 2) {
            settodayLeadPage(1)
        } else if (todayLeadPage === 3) {
            settodayLeadPage(2)
        }
    }

    const handleExpiryLeadBack = () => {
        if (expiryLeadPage < 1) {
            setExpiryLeadPage(3)
        }
        else if (expiryLeadPage === 2) {
            setExpiryLeadPage(1)
        } else if (expiryLeadPage === 3) {
            setExpiryLeadPage(2)
        }
    }

    const handleExpiryLeadNext = () => {
        if (expiryLeadPage > 3) {
            setExpiryLeadPage(1)
        } else if (expiryLeadPage === 2 && expiry_lead.totalRecords > 8) {
            setExpiryLeadPage(3)
        } else if (expiryLeadPage === 1 && expiry_lead.totalRecords > 4) {
            setExpiryLeadPage(2)
        }
    }

    const openCalenderCard = () => {
        setOpenCalender(true)
    }

    const noti_data_unread_count = useMemo(
        () => notification_data?.filter((noti) => noti.isread === false),
        [notification_data]
    );

    const hasPermission = (perm) => checkAdminRole && permissionsDetails?.[perm] || permissionsDetails?.[perm];

    // Enhanced styling
    const styles = {
        dateCard: {
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '16px',
            padding: '16px',
            color: 'white',
            boxShadow: '0 8px 24px rgba(102, 126, 234, 0.25)',
            transition: 'all 0.3s ease',
            '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 12px 32px rgba(102, 126, 234, 0.35)',
            }
        },
        statCard: {
            background: 'white',
            borderRadius: '16px',
            padding: '20px',
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
            transition: 'all 0.3s ease',
            border: '1px solid rgba(0, 0, 0, 0.06)',
            position: 'relative',
            overflow: 'hidden',
            '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 12px 32px rgba(0, 0, 0, 0.12)',
            },
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '4px',
                background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
            }
        },
        sectionHeader: {
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            borderRadius: '12px',
            padding: '16px 20px',
            marginBottom: '16px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
        },
        iconButton: {
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            padding: '8px',
            borderRadius: '8px',
            '&:hover': {
                background: 'rgba(255, 255, 255, 0.2)',
                transform: 'scale(1.1)',
            }
        },
        emptyState: {
            height: '300px',
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            alignItems: 'center',
            display: 'flex',
            mt: 1,
            justifyContent: 'center',
            borderRadius: '16px',
            border: '2px dashed rgba(0, 0, 0, 0.1)',
        },
        countBadge: {
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '20px',
            padding: '4px 12px',
            color: 'white',
            fontSize: '14px',
            fontWeight: 600,
            marginLeft: '8px',
            boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
        }
    };

    return (
        <>
            {loader ? (
                <Fade in={loader}>
                    <Box sx={{ 
                        height: '300px', 
                        alignItems: 'center', 
                        display: 'flex', 
                        mt: 0.5, 
                        justifyContent: 'center', 
                        borderRadius: '10px' 
                    }}>
                        <TailSpin
                            height="40"
                            width="40"
                            color="#667eea"
                            ariaLabel="tail-spin-loading"
                            radius="3"
                            visible={true}
                        />
                    </Box>
                </Fade>
            ) : (
                <Fade in={!loader} timeout={600}>
                    <Parent>
                        <Grid container spacing={{ xs: 2, md: 3, lg: 4, xl: 4 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                            <CountLayOut item xs={1.5} sm={1.5} md={1.5}>
                                {/* Enhanced Date Card */}
                                <Zoom in={true} timeout={400}>
                                    <Box sx={styles.dateCard}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Tooltip title="Calendar" placement="top">
                                                    <Box sx={styles.iconButton} onClick={openCalenderCard}>
                                                        <CalenderIcon />
                                                    </Box>
                                                </Tooltip>
                                                <Typography sx={{ fontWeight: 500, fontSize: '14px' }}>
                                                    {moment(Number(new Date(start_date).getTime())).format('DD MMM')} to {moment(Number(new Date(end_date).getTime())).format('DD MMM')}
                                                </Typography>
                                            </Box>
                                            <Tooltip title="Reset Date Range" placement="top">
                                                <Box sx={styles.iconButton} onClick={handleResetDate}>
                                                    <ResetIcon />
                                                </Box>
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                </Zoom>

                                {/* Enhanced Stat Cards */}
                                <Link to={permissionsDetails?.perm_lead_view ? '/dashboard/leadlist' : ''} style={{ textDecoration: 'none' }}>
                                    <Zoom in={true} timeout={500}>
                                        <Box sx={{ ...styles.statCard, mt: 2 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                <Header2>Leads</Header2>
                                                <LeadIconBox sx={{height:"30px",width:"30px"}}>
                                                    <LeadIcon height={40} width={40} />
                                                </LeadIconBox>
                                            </Box>
                                            <CountCard2>
                                                <BrownColorTypo>Open</BrownColorTypo>
                                                <BlackColorNum>{permissionsDetails?.perm_lead_view ? dashboard_count?.opened_lead : 0}</BlackColorNum>
                                            </CountCard2>
                                            <CountCard2>
                                                <SkyBlueTypo>Open Follow-up</SkyBlueTypo>
                                                <BlackColorNum>{permissionsDetails?.perm_lead_view ? dashboard_count?.followup_count : 0}</BlackColorNum>
                                            </CountCard2>
                                            <CountCard2>
                                                <GreenTypo>Converted</GreenTypo>
                                                <BlackColorNum>{permissionsDetails?.perm_lead_view ? dashboard_count?.converted_lead : 0}</BlackColorNum>
                                            </CountCard2>
                                            <CountCard2>
                                                <RedTypo>Lost</RedTypo>
                                                <BlackColorNum>{permissionsDetails?.perm_lead_view ? dashboard_count?.lost_lead : 0}</BlackColorNum>
                                            </CountCard2>
                                            <CountCard2>
                                                <GreyTypo>Closed</GreyTypo>
                                                <BlackColorNum>{permissionsDetails?.perm_lead_view ? dashboard_count?.closed_lead : 0}</BlackColorNum>
                                            </CountCard2>
                                        </Box>
                                    </Zoom>
                                </Link>

                                <Link to={permissionsDetails?.perm_opportunity_view ? '/dashboard/opportunitylist' : ''} style={{ textDecoration: 'none' }}>
                                    <Zoom in={true} timeout={600}>
                                        <Box sx={{ ...styles.statCard, mt: 2 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                <Header2>Opportunity</Header2>
                                                <OppoIconBox sx={{height:"30px",width:"30px"}}>
                                                    <OpportunityIcon height={40} width={40} />
                                                </OppoIconBox>
                                            </Box>
                                            <CountCard2>
                                                <SkyBlueTypo>Open</SkyBlueTypo>
                                                <BlackColorNum>{permissionsDetails?.perm_opportunity_view ? dashboard_count?.opened_oppo : 0}</BlackColorNum>
                                            </CountCard2>
                                            <CountCard2>
                                                <GreenTypo>Won</GreenTypo>
                                                <BlackColorNum>{permissionsDetails?.perm_opportunity_view ? dashboard_count?.won_oppo : 0}</BlackColorNum>
                                            </CountCard2>
                                            <CountCard2>
                                                <RedTypo>Lost</RedTypo>
                                                <BlackColorNum>{permissionsDetails?.perm_opportunity_view ? dashboard_count?.lost_oppo : 0}</BlackColorNum>
                                            </CountCard2>
                                        </Box>
                                    </Zoom>
                                </Link>

                                <Link to={permissionsDetails?.perm_task_view ? '/dashboard/tasklist' : ''} style={{ textDecoration: 'none' }}>
                                    <Zoom in={true} timeout={700}>
                                        <Box sx={{ ...styles.statCard, mt: 2 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                <Header2>Tasks</Header2>
                                                <OppoIconBox sx={{ backgroundColor: '#9b9e04' ,height:"30px",width:"30px"}}>
                                                    <TaskIcon height={40} width={40} />
                                                </OppoIconBox>
                                            </Box>
                                            <CountCard2>
                                                <SkyBlueTypo>Open</SkyBlueTypo>
                                                <BlackColorNum>{permissionsDetails?.perm_task_view ? dashboard_count?.task_opened : 0}</BlackColorNum>
                                            </CountCard2>
                                            <CountCard2>
                                                <GreenTypo>Closed</GreenTypo>
                                                <BlackColorNum>{permissionsDetails?.perm_task_view ? dashboard_count?.task_closed : 0}</BlackColorNum>
                                            </CountCard2>
                                            <CountCard2>
                                                <GreyTypo>Expired</GreyTypo>
                                                <BlackColorNum>0</BlackColorNum>
                                            </CountCard2>
                                        </Box>
                                    </Zoom>
                                </Link>
                            </CountLayOut>

                            {/* Today's Leads Section */}
                            <TodayLeadLayOut item xs={2} sm={4.250} md={4.250}>
                                <Slide direction="right" in={true} timeout={500}>
                                    <Box sx={styles.sectionHeader}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <T2popupSubText sx={{ fontSize: '16px', fontWeight: 600 }}>
                                                Today's Leads
                                            </T2popupSubText>
                                            <Box sx={styles.countBadge}>
                                                {today_lead?.totalRecords || 0}
                                            </Box>
                                        </Box>
                                        <Header sx={{ mt: 2 }}>
                                            <PagiLayout>
                                                <Typography onClick={handleTodayLeadBack} sx={{ cursor: 'pointer', transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.2)' } }}>
                                                    <BackwardIcon />
                                                </Typography>
                                                {todayLeadPage == 1 ? <FilledDotSelected /> : <PaginationDot />}
                                                {today_lead?.totalRecords > 4 ? todayLeadPage === 2 ? <FilledDotSelected /> : <PaginationDot /> : ''}
                                                {today_lead?.totalRecords > 8 ? todayLeadPage === 3 ? <FilledDotSelected /> : <PaginationDot /> : ''}
                                                <Typography onClick={handleTodayLeadNext} sx={{ cursor: 'pointer', transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.2)' } }}>
                                                    <ForwardIcon />
                                                </Typography>
                                                {permissionsDetails?.perm_lead_view ? (
                                                    <Link to='leadlist' state={{ For: "dashboard", view: "todays_lead" }}>
                                                        <Box sx={{ transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.1)' } }}>
                                                            <TableIcon />
                                                        </Box>
                                                    </Link>
                                                ) : ''}
                                            </PagiLayout>
                                        </Header>
                                    </Box>
                                </Slide>

                                <Box sx={{ flexGrow: 1 }}>
                                    {today_lead?.today_followups?.length > 0 ? (
                                        <Fade in={true} timeout={800}>
                                            <Grid container spacing={{ xs: 2, md: 1 }} columns={{ xs: 2, sm: 8, md: 8, lg: 12 }}>
                                                {today_lead?.today_followups?.map((followup, index) => (
                                                    <Zoom in={true} timeout={300 * (index + 1)} key={index}>
                                                        <Grid item>
                                                            <DashboardCard setLoader={setLoader} followup={followup} />
                                                        </Grid>
                                                    </Zoom>
                                                ))}
                                            </Grid>
                                        </Fade>
                                    ) : (
                                        <Box sx={styles.emptyState}>
                                            <Typography sx={{ textAlign: 'center', color: '#667eea', fontWeight: 500, fontSize: '16px' }}>
                                                No Leads Available
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </TodayLeadLayOut>

                            {/* Expiring Leads Section */}
                            <ExpiringLeadLayout item xs={2} sm={4.250} md={4.250}>
                                <Slide direction="left" in={true} timeout={500}>
                                    <Box sx={styles.sectionHeader}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <T2popupSubText sx={{ fontSize: '16px', fontWeight: 600 }}>
                                                Expiring Leads
                                            </T2popupSubText>
                                            <Box sx={styles.countBadge}>
                                                {expiry_lead?.totalRecords || 0}
                                            </Box>
                                        </Box>
                                        <Header sx={{ mt: 2 }}>
                                            <PagiLayout>
                                                <Typography onClick={handleExpiryLeadBack} sx={{ cursor: 'pointer', transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.2)' } }}>
                                                    <BackwardIcon />
                                                </Typography>
                                                {expiryLeadPage == 1 ? <FilledDotSelected /> : <PaginationDot />}
                                                {expiry_lead?.totalRecords > 4 ? expiryLeadPage === 2 ? <FilledDotSelected /> : <PaginationDot /> : ''}
                                                {expiry_lead?.totalRecords > 8 ? expiryLeadPage === 3 ? <FilledDotSelected /> : <PaginationDot /> : ''}
                                                <Typography onClick={handleExpiryLeadNext} sx={{ cursor: 'pointer', transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.2)' } }}>
                                                    <ForwardIcon />
                                                </Typography>
                                                {permissionsDetails?.perm_lead_view ? (
                                                    <Link to='leadlist' state={{ For: "dashboard", view: "expiring_lead" }}>
                                                        <Box sx={{ transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.1)' } }}>
                                                            <TableIcon />
                                                        </Box>
                                                    </Link>
                                                ) : ''}
                                            </PagiLayout>
                                        </Header>
                                    </Box>
                                </Slide>

                                <Box sx={{ flexGrow: 1 }}>
                                    {expiry_lead?.follow_up_near_to_expire?.length > 0 ? (
                                        <Fade in={true} timeout={800}>
                                            <Grid container spacing={{ xs: 2, md: 1 }} columns={{ xs: 2, sm: 8, md: 8, lg: 12 }}>
                                                {expiry_lead?.follow_up_near_to_expire?.map((followup, index) => (
                                                    <Zoom in={true} timeout={300 * (index + 1)} key={index}>
                                                        <Grid item>
                                                            <DashboardCard setLoader={setLoader} For='expiry' followup={followup} />
                                                        </Grid>
                                                    </Zoom>
                                                ))}
                                            </Grid>
                                        </Fade>
                                    ) : (
                                        <Box sx={styles.emptyState}>
                                            <Typography sx={{ textAlign: 'center', color: '#667eea', fontWeight: 500, fontSize: '16px' }}>
                                                No Leads Available
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </ExpiringLeadLayout>

                            {/* Actions & COF Section */}
                            <WishesLayout item xs={2} sm={2} md={2}>
                                <Zoom in={true} timeout={800}>
                                    <Box sx={{ ...styles.sectionHeader, display: 'flex', justifyContent: 'center', gap: 2 }}>
                                        {hasPermission('perm_user_view') && (
                                            <Tooltip title="Users" placement="top">
                                                <Box sx={styles.iconButton} onClick={() => navigate('/dashboard/userlist')}>
                                                    <UserIcon />
                                                </Box>
                                            </Tooltip>
                                        )}
                                        {hasPermission('perm_contact_view') && (
                                            <Tooltip title="Contacts" placement="top">
                                                <Box sx={styles.iconButton} onClick={() => navigate('/dashboard/contactlist')}>
                                                    <ContactIcon />
                                                </Box>
                                            </Tooltip>
                                        )}
                                        {hasPermission('perm_company_view') && (
                                            <Tooltip title="Companies" placement="top">
                                                <Box sx={styles.iconButton} onClick={() => navigate('/dashboard/companylist')}>
                                                    <CompanyIcon />
                                                </Box>
                                            </Tooltip>
                                        )}
                                        <Tooltip title="Notifications" placement="top">
                                            <Box sx={styles.iconButton} onClick={openNotificationModal}>
                                                <NotificationIcon 
                                                    count={noti_data_unread_count?.length || ''} 
                                                    w={10} 
                                                    h={30} 
                                                />
                                            </Box>
                                        </Tooltip>
                                    </Box>
                                </Zoom>

                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Link to={permissionsDetails?.perm_cof_view ? '/dashboard/coflist' : ''} style={{ textDecoration: 'none' }}>
                                            <Zoom in={true} timeout={900}>
                                                <Box sx={styles.statCard}>
                                                    <Header2 sx={{ textAlign: 'center', mb: 2 }}>COF Details</Header2>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, py: 1 }}>
                                                        <T2popupSubText sx={{ color: themeColor.palette.BrandColor }}>Pending:</T2popupSubText>
                                                        <H3SubHeader>{!permissionsDetails?.perm_cof_view ? 0 : dashboard_count?.pending_cof < 10 ? `0${dashboard_count?.pending_cof}` : dashboard_count?.pending_cof}</H3SubHeader>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, py: 1 }}>
                                                        <T2popupSubText sx={{ color: '#088F05' }}>Approved:</T2popupSubText>
                                                        <H3SubHeader>{!permissionsDetails?.perm_cof_view ? 0 : dashboard_count?.approved_cof < 10 ? `0${dashboard_count?.approved_cof}` : dashboard_count?.approved_cof}</H3SubHeader>
                                                    </Box>
                                                </Box>
                                            </Zoom>
                                        </Link>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Link to={permissionsDetails?.perm_service_view ? '/dashboard/servicelist' : ''} style={{ textDecoration: 'none' }}>
                                            <Zoom in={true} timeout={1000}>
                                                <Box sx={styles.statCard}>
                                                    <Header2 sx={{ textAlign: 'center', mb: 2 }}>Service ID Details</Header2>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, py: 1 }}>
                                                        <T2popupSubText sx={{ color: themeColor.palette.BrandColor }}>Pending:</T2popupSubText>
                                                        <H3SubHeader>{!permissionsDetails?.perm_service_view ? 0 : dashboard_count?.pending_service_id < 10 ? `0${dashboard_count?.pending_service_id}` : dashboard_count?.pending_service_id}</H3SubHeader>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, py: 1 }}>
                                                        <T2popupSubText sx={{ color: '#088F05' }}>Approved:</T2popupSubText>
                                                        <H3SubHeader>{!permissionsDetails?.perm_service_view ? 0 : dashboard_count?.approved_service_id < 10 ? `0${dashboard_count?.approved_service_id}` : dashboard_count?.approved_service_id}</H3SubHeader>
                                                    </Box>
                                                </Box>
                                            </Zoom>
                                        </Link>
                                    </Grid>
                                </Grid>
                            </WishesLayout>
                        </Grid>

                        {openCalender && <CalenderCard days={days} setDays={setDays} start_date={start_date} end_date={end_date} setStart_Date={setStart_Date} setEnd_Date={setEnd_Date} open={openCalender} setOpenCalender={setOpenCalender} />}

                        <FloatingListModal open={open} setOpen={setOpen} handleClose={handleClose} />
                        <NotificationModal notification_data={notification_data} open={opennotificationmodal} setOpen={setOpenNotificationModal} handleClose={handlecloseNotificationModal} />
                        <FloatingButton onClick={handleClickOpen} />
                    </Parent>
                </Fade>
            )}
        </>
    )
}

export default Dashboardnew